<template>
  <div class="swc-page">
    <div class="swc-header-spacer" aria-hidden="true"></div>
    <div class="swc-header-fixed">
      <div class="swc-header-inner">
        <img
          class="swc-back"
          src="../../assets/withdrawal_v2/back2.png"
          alt=""
          @click="goBack"
        />
        <p class="swc-title">{{ $t("guild_confirm_withdraw_info") }}</p>
      </div>
    </div>

    <div class="swc-body">
      <div class="swc-card">
        <div class="swc-row">
          <span>{{ $t("guild_withdraw_amount_label") }}</span>
          <span class="swc-coin">
            <span><img src="../../assets/withdrawal_v2/$.png" alt="" />{{ formatCoin(withdrawAmount) }}</span>
            <!-- 法币展示：档位的 cc 币种 + num 金额，括号跟在 pocket 币后面 -->
            <span v-if="detailsNewObj.cc && detailsNewObj.num" class="swc-fiat">
              ({{ detailsNewObj.cc }} {{ detailsNewObj.num }})
            </span>
          </span>
        </div>
        <!-- 隐藏手续费 -->
        <!-- 手续费：feeRate/feeFixed 存在且非0才展示对应部分；两者皆无则整行不展示 -->
        <!-- <div  class="swc-row">
          <span>
            {{ $t("guild_reference_fee") }}
            <span v-if="detailsNewObj.feeFixed != null && detailsNewObj.feeFixed !== 0" >
              ({{ detailsNewObj.cc }} {{ detailsNewObj.feeFixed/100 }}
            </span>
            <span v-if=" (detailsNewObj.feeRate != null && detailsNewObj.feeRate !== 0) && (detailsNewObj.feeFixed != null && detailsNewObj.feeFixed !== 0)">+</span>
            <span v-if="detailsNewObj.feeRate != null && detailsNewObj.feeRate !== 0">
              {{ detailsNewObj.feeRate }}%)
            </span>
          </span>
          <span v-if="feeAmount !== ''" class="swc-coin">{{ detailsNewObj.cc }} {{ feeAmount.toFixed(2) }}</span>
        </div> -->
        <div v-if="isPlatformFlow" class="swc-row">
          <span>{{ $t("guild_estimated_arrival_time") }}</span>
          <span class="swc-row-value">{{ $t("guild_settlement_weekly_process") }}</span>
        </div>
        <div v-else-if="arrivalTime" class="swc-row">
          <span>{{ $t("guild_estimated_arrival_time") }}</span>
          <span class="swc-row-value">{{ arrivalTime }}{{$t("Weekly_Cp.day")}}</span>
        </div>
      </div>

      <div v-if="confirmRows.length" class="swc-card">
        <!-- 平台结算跳转过来不展示"提现渠道"这一行（无渠道名） -->
        <div v-if="!isPlatformFlow" class="swc-row">
          <span>{{ $t("withdrawal_channel") }}</span>
          <span class="swc-row-value">{{ channelName }}</span>
        </div>
        <div v-for="(row, idx) in confirmRows" :key="idx" class="swc-row">
          <span>{{ row.label }}</span>
          <span class="swc-row-value">{{ row.value }}</span>
        </div>
      </div>

      <div class="swc-warn">
        <p class="swc-warn-title">{{ $t("guild_bind_notice_title") }}</p>
        <p>
          {{ $t("guild_confirm_info_tip") }}
          <span class="swc-modify" @click="openBindSheet">{{ $t("guild_modify") }} {{ modifyArrow }}</span>
        </p>
      </div>
    </div>

    <div class="swc-footer">
      <button type="button" class="swc-submit" :disabled="submitting" @click="submitWithdraw">
        {{ $t("guild_confirm_submit") }}
      </button>
    </div>

    <channel-bind-sheet
      v-if="!isPlatformFlow"
      :visible="showBindSheet"
      :channel-name="channelName"
      :details-obj="detailsObj"
      :item-id="itemId"
      :sabank-list="sabankList"
      :token="token"
      :uid="uid"
      :device-id="deviceId"
      :lang="lang"
      @close="showBindSheet = false"
      @bound="onBound"
    />

    <platform-settlement-bind-sheet
      v-else
      :visible="showBindSheet"
      :down-num="downNum"
      :value="settlementForm"
      @close="showBindSheet = false"
      @bound="onSettlementBound"
    />

    <withdraw-success-modal
      :visible="showSuccess"
      :workdays="successWorkdays"
      :tip-key="successTipKey"
      :tip-params="successTipParams"
      @confirm="goWithdrawalHome"
    />

    <van-overlay :show="submitting">
      <van-loading
        size="50px"
        style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)"
      />
    </van-overlay>
    <!-- 去认证的弹窗：四个提现接口返回 501915 时展示；关闭按钮触发 close -->
    <certification-pop
      v-if="showCertification"
      :err-code="certErrCode"
      :page-source="isPlatformFlow ? '平台结算' : '自提现'"
      @close="showCertification = false"
    ></certification-pop>
  </div>
</template>

<script>
/**
 * 确认提现信息页（2026-06-08）
 *
 * 自提现与平台结算共用：
 *   - 上半部分：提现金额 + 到账说明
 *   - 下半部分：confirmRows 动态渲染收款信息
 *   - 提交成功：withdraw-success-modal
 *
 * 路由 query.flow：
 *   - self（默认）：自提现，由 selfWithdrawFlow.goConfirmPage 带入
 *   - platform：平台结算，由 platform-settlement-panel 带入
 */
import axios from "axios";
import { Toast, Overlay, Loading } from "vant";
import "vant/lib/overlay/style";
import "vant/lib/loading/style";
import WithdrawSuccessModal from "@/components/withdrawal/withdraw-success-modal.vue";
import ChannelBindSheet from "@/components/withdrawal/channel-bind-sheet.vue";
import PlatformSettlementBindSheet from "@/components/withdrawal/platform-settlement-bind-sheet.vue";
// 真人认证弹窗
import CertificationPop from "@/components/withdrawal/certification_pop.vue"
import { getArrivalTimeText, buildApplyParams, buildConfirmRows } from "@/utils/withdrawChannel";
import {
  buildSettlementConfirmRows,
  saveSettlementInfo,
} from "@/utils/platformSettlement";
import {
  BIND_TYPE_SETTLEMENT,
  BIND_TYPE_WITHDRAW,
  saveBindInfo,
  loadBindInfo,
} from "@/utils/bindInfo";

export default {
  name: "selfWithdrawConfirm",
  components: {
    ChannelBindSheet,
    PlatformSettlementBindSheet,
    WithdrawSuccessModal,
    VanOverlay: Overlay,
    [Loading.name]: Loading,
    CertificationPop
  },
  data() {
    return {
      /** 流程类型：self | platform */
      flow: "self",
      /** initForWeb.infos，渠道绑定信息与到账描述 */
      detailsObj: {},
      /** 所选提现档位（含 USD、id、channel 等） */
      detailsNewObj: {},
      /** 平台结算绑定表单 */
      settlementForm: {},
      /** 提现 P 币数量（平台结算来自 query.amount） */
      withdrawAmount: 0,
      /** 平台结算最低提现数（绑定半层提示用） */
      downNum: 0,
      /** 提现渠道 ID */
      itemId: 0,
      /** 沙特等渠道的银行列表 */
      sabankList: [],
      token: "",
      uid: "",
      /** 接口请求头 lang，来源 localStorage.data.lang */
      lang: "",
      deviceId: "",
      /** 渠道名称，绑定半层标题展示 */
      channelName: "",
      showBindSheet: false,
      showSuccess: false,
      submitting: false,
      /** 成功弹窗预计到账工作日数 */
      successWorkdays: 3,
      /** 确认页下方按渠道展示的收款信息行 */
      confirmRows: [],
      /** bindInfo 接口返回的预计到账时间（bindInfo 优先） */
      bindArrivalTime: "",
      /** 是否展示真人认证弹窗（提现接口返回 501915 时置 true） */
      showCertification: false,
      /** 触发认证弹窗的接口错误码（501915 / 501918），传给弹窗以区分 App 方法 */
      certErrCode: 0,
    };
  },
  computed: {
    // 是否为平台结算流程
    isPlatformFlow() {
      return this.flow === "platform";
    },
    /** 预计到账时间文案：优先 bindInfo 接口返回的 arrivalTime，再兜底档位/initForWeb 字段 */
    arrivalTime() {
      return (
        this.bindArrivalTime ||
        this.detailsNewObj.arrivalTime ||
        getArrivalTimeText(this.detailsObj) ||
        ""
      );
    },
    /** 是否有手续费：feeRate 或 feeFixed 存在且非 0（否则不展示手续费整行） */
    hasFee() {
      const n = this.detailsNewObj || {};
      return (
        (n.feeRate != null && Number(n.feeRate) !== 0) ||
        (n.feeFixed != null && Number(n.feeFixed) !== 0)
      );
    },
    /** 手续费金额：(提现金额(usd) × feeRate + feeFixed) / 100；保留两位小数；无手续费或值缺失时返回空 */
    feeAmount() {
      const n = this.detailsNewObj || {};
      if (n.usd == null || !this.hasFee) return "";
      const amount = Number(n.usd) || 0;
      const rate = Number(n.feeRate) || 0;
      const fixed = Number(n.feeFixed) || 0;
      const raw = (amount * rate + fixed) / 100;
      // 保留两位小数：第三位存在时第二位进一（四舍五入到分，加极小值避免浮点误差）
      return Math.round((raw + Number.EPSILON) * 100) / 100;
    },
    // 成功提示文案 key：平台结算与自提现不同
    successTipKey() {
      return this.isPlatformFlow
        ? "guild_platform_settlement_success_tip"
        : "guild_withdraw_success_tip";
    },
    // 成功提示插值：平台结算无参数，自提现用到账工作日 {s}
    successTipParams() {
      return this.isPlatformFlow ? {} : { s: this.successWorkdays };
    },
    /** 阿语 RTL 下「修改」链接箭头方向与 LTR 相反 */
    modifyArrow() {
      return this.$i18n.locale === "ar" ? "<" : ">";
    },
  },
  /** 解析路由 → 登录态 → 语言 → 确认行（平台结算流程额外从服务端回填已保存信息） */
  created() {
    this.parseRoute();
    this.initAuth();
    this.initLang();
    this.refreshConfirmRows();
    // 平台结算：用服务端 bindInfo 已保存信息回填表单，避免重复输入
    if (this.isPlatformFlow) this.loadSettlementFromServer();
    // 自提现：从服务端 bindInfo 加载已绑定渠道信息，补齐确认页姓名/卡号/地址等展示
    // 注意：自定义金额 detailsNewObj.id=0，不能用 id 判断，统一调用（内部按 itemId 判断）
    else this.loadWithdrawBindInfo();
    document.title = this.$t("guild_confirm_withdraw_info");
  },
  methods: {
    /**
     * 解析路由 query，还原上一页 initForWeb + 档位选择结果
     * 正常流程由 selfWithdrawFlow.goConfirmPage 跳转带入
     */
    parseRoute() {
      const q = this.$route.query;
      this.flow = q.flow === "platform" ? "platform" : "self";

      if (this.isPlatformFlow) {
        this.withdrawAmount = Number(q.amount || 0);
        this.settlementForm = JSON.parse(q.settlement || "{}");
        this.downNum = Number(q.downNum || 0);
        return;
      }

      this.detailsNewObj = JSON.parse(q.newobj || "{}");
      this.detailsObj = JSON.parse(q.obj || "{}");
      this.itemId = Number(q.id);
      this.sabankList = JSON.parse(q.sabankList || "[]");
      this.channelName = q.channelName || "";
      // 成功提示预计到账：与确认页到账时间字段一致（档位 arrivalTime 优先，避免一直走兜底 3）
      this.successWorkdays =
        q.workdays ||
        this.detailsNewObj.arrivalTime ||
        this.detailsObj.arrivalWorkdays ||
        3;
      // 提现金额：优先路由单独透传的 amount（goConfirmPage 传入），兜底档位 usd/USD 字段
      const passAmount = q.amount !== undefined && q.amount !== "" ? Number(q.amount) : NaN;
      this.withdrawAmount = Number.isNaN(passAmount)
        ? Number(this.detailsNewObj.usd || this.detailsNewObj.USD || 0)
        : passAmount;
    },
    /** 从 localStorage.data 读取登录态与语言（App WebView getUserInfo 写入） */
    initAuth() {
      const raw = localStorage.getItem("data");
      if (!raw) return;
      try {
        const data = JSON.parse(raw);
        this.token = data.token;
        this.uid = String(data.uid ?? data.userId ?? "");
        this.lang = data.lang || navigator.language;
        this.deviceId = data.deviceId || "";
      } catch (e) {
        /* ignore */
      }
    },
    /**
     * 初始化 UI 语言：localStorage.data.lang → $i18n.locale + html[lang]
     */
    initLang() {
      const lang = this.lang || navigator.language;
      const langs = String(lang).substring(0, 2);
      if (langs === "zh") {
        this.$i18n.locale =
          lang === "zh-TW" || lang === "zh-HK" ? "tc" : "zh";
      } else if (langs === "en") {
        this.$i18n.locale = "en";
      } else if (langs === "ar") {
        this.$i18n.locale = "ar";
      } else if (langs === "tr") {
        this.$i18n.locale = "tr";
      } else if (langs === "es") {
        this.$i18n.locale = "es";
      } else if (langs === "pt") {
        this.$i18n.locale = "pt";
      } else if (langs === "fr") {
        this.$i18n.locale = "fr";
      } else if (langs === "id") {
        this.$i18n.locale = "id";
      } else if (langs === "ms") {
        this.$i18n.locale = "ms";
      } else {
        this.$i18n.locale = "en";
      }
      this.lang = lang;
      document.querySelector("html").setAttribute("lang", this.$i18n.locale);
    },
    /** 金额千分位格式化 */
    formatCoin(val) {
      return Number(val || 0).toLocaleString("en-US");
    },
    /** 根据流程动态生成下方收款信息展示行 */
    refreshConfirmRows() {
      if (this.isPlatformFlow) {
        this.confirmRows = buildSettlementConfirmRows(
          this.settlementForm,
          this.$t.bind(this)
        );
        return;
      }
      // 构建收款信息行；labels 为后端未下发 label 文案时的 i18n 兜底，保证"绑定过就展示"
      this.confirmRows = buildConfirmRows(this.detailsObj, this.itemId, {
        name: this.$t("guild_name"),
        account: this.$t("guild_bank_account"),
        country: this.$t("guild_country"),
        bank: this.$t("guild_bank_name"),
        iban: this.$t("guild_iban"),
        whatsApp: this.$t("guild_whatsapp"),
        documentType: this.$t("guild_document_type"),
        documentId: this.$t("guild_document_id"),
        accountType: this.$t("guild_account_type"),
        address: this.$t("guild_address"),
      });
    },
    /** 返回上一页（自提现面板） */
    goBack() {
      this.$router.go(-1);
    },
    /** 打开渠道绑定半层，修改收款信息 */
    openBindSheet() {
      this.showBindSheet = true;
    },
    /** 绑定半层保存成功：关闭半层并刷新渠道信息 */
    onBound() {
      this.showBindSheet = false;
      this.reloadChannelInfo();
    },
    /** 自提现：从服务端 bindInfo 加载已绑定的渠道收款信息，补齐确认页姓名/国家/账号等展示 */
    loadWithdrawBindInfo() {
      // bizKey=渠道 id；无渠道 id 或不在 App 内时不查询
      if (!this.itemId) return;
      loadBindInfo({
        bindType: BIND_TYPE_WITHDRAW,
        bizKey: String(this.itemId),
        serviceIp: this.$serviceIp,
        token: this.token,
        uid: this.uid,
        deviceId: this.deviceId,
        lang: this.lang,
      }).then((vo) => {
        // vo 为 BindInfoVO；预计到账时间用 bindInfo 返回的 arrivalTime（优先）
        this.bindArrivalTime = (vo && vo.arrivalTime) || "";
        // 成功弹窗预计到账时间与确认页一致（bindInfo arrivalTime 优先），避免兜底 3
        if (this.bindArrivalTime) {
          this.successWorkdays = this.bindArrivalTime;
        }
        // 已保存的收款信息在 infoJson 中
        const saved = (vo && vo.infoJson) || null;
        if (saved) {
          // 将服务端已保存的收款信息合并进 detailsObj，供 buildConfirmRows 读取展示
          this.detailsObj = { ...this.detailsObj, ...saved };
          // 补齐未在接口返回的国家/账号等展示字段
          if (!this.detailsObj.country && this.detailsObj.countryCode) {
            this.detailsObj.country = this.detailsObj.countryCode;
          }
        }
        // 无论是否取到绑定信息都刷新确认行，避免「修改保存后」Label 模块消失
        this.refreshConfirmRows();
      });
    },
    /** 平台结算：从服务端 bindInfo 加载已保存信息并回填表单（bindType=2, bizKey 写死 country） */
    loadSettlementFromServer() {
      const country = (this.settlementForm.country || {}).code || "";
      // 无国家码时（初始表单无已选国家）不查询
      if (!country) return;
      loadBindInfo({
        bindType: BIND_TYPE_SETTLEMENT,
        bizKey: "country",
        serviceIp: this.$serviceIp,
        token: this.token,
        uid: this.uid,
        deviceId: this.deviceId,
        lang: this.lang,
      }).then((vo) => {
        // vo 为 BindInfoVO；已保存的结算信息在 infoJson 中
        const saved = (vo && vo.infoJson) || null;
        if (!saved) return;
        // 服务端信息优先：合并到当前表单（保留国家/银行结构）
        this.settlementForm = { ...this.settlementForm, ...saved };
        this.refreshConfirmRows();
      });
    },
    /** 平台结算绑定半层保存成功：走服务端保存（bindType=2, bizKey 写死 country）并刷新确认行 */
    onSettlementBound(form) {
      this.showBindSheet = false;
      this.settlementForm = { ...form };
      // 服务端持久化平台结算信息（bizKey 写死 country），localStorage 作为本地兜底
      saveBindInfo({
        bindType: BIND_TYPE_SETTLEMENT,
        bizKey: "country",
        info: this.settlementForm,
        serviceIp: this.$serviceIp,
        token: this.token,
        uid: this.uid,
        deviceId: this.deviceId,
        lang: this.lang,
      });
      saveSettlementInfo(this.uid, this.settlementForm);
      this.refreshConfirmRows();
    },
    /**
     * 重新拉取 initForWeb，更新 infos / sabankList 与确认行
     * 用户在确认页点击「修改」并保存后调用
     */
    reloadChannelInfo() {
      axios
        .get(
          this.$serviceIp +
            `api/trade/card/tx/initForWeb?token=${this.token}&uid=${this.uid}&id=${this.itemId}`,
          { headers: { deviceId: this.deviceId, lang: this.lang } }
        )
        .then((res) => {
          if (res.data.code === 200) {
            this.detailsObj = res.data.data.infos || {};
            this.sabankList = res.data.data.sabankList || [];
            // initForWeb 不含已绑定信息，需重新从 bindInfo 加载合并后再刷新确认行
            this.loadWithdrawBindInfo();
          }
        });
    },
    /** 组装 applyForWeb 的 params，各渠道字段见 withdrawChannel.buildApplyParams */
    buildSubmitParams() {
      return buildApplyParams(this.itemId, this.detailsObj, this.detailsNewObj);
    },
    /**
     * 确认提交提现
     * 固定档位 mode=1；自定义金额 id===0 时 mode=2 + pocketCoin（对齐旧 submitBtn）
     */
    submitWithdraw() {
      if (this.submitting) return;
      this.submitting = true;
      // 如果是平台结算
      if (this.isPlatformFlow) {
        this.submitPlatformSettlement();
        return;
      }
      this.submitSelfWithdraw();
    },
    submitSelfWithdraw() {
      const dataObj = {};
      if (this.detailsNewObj.id === 0) {
        dataObj.cid = String(this.detailsNewObj.channel);
        dataObj.mode = 2;
        dataObj.pocketCoin = this.detailsNewObj.USD;
      } else {
        dataObj.cid = String(this.detailsNewObj.id);
        dataObj.mode = 1;
      }
      axios({
        url: this.$serviceIp + "api/trade/card/tx/applyForWeb",
        method: "post",
        headers: { deviceId: this.deviceId, lang: this.lang },
        data: { ...dataObj, params: this.buildSubmitParams() },
        params: { token: this.token, uid: this.uid },
      })
        .then((res) => {
          if (res.data.code === 200) {
            this.showSuccess = true;

            // 501912 , 501918, 501923  都归为 性别认证失败场景,需性别认证
            // 501915 需真人认证拦截
          } else if (res.data.code === 501915 || res.data.code === 501918 || res.data.code === 501912 || res.data.code === 501923) {
            // 需真人认证：展示认证弹窗（记录错误码供弹窗区分 App 方法）
            this.certErrCode = res.data.code;
            this.showCertification = true;
          } else {
            Toast(res.data.message || this.$t("transfer.error"));
          }
        })
        .catch(() => Toast(this.$t("transfer.error")))
        .finally(() => {
          this.submitting = false;
        });
    },
    // 平台结算
    submitPlatformSettlement() {
      axios({
        url: `${this.$serviceIp}api/trade/card/tx/guildSettlementApply`,
        method: "post",
        headers: {
          deviceId: this.deviceId,
          version: "3.0",
          lang: this.lang,
        },
        data: {
          pocketCoinNum: Number(this.withdrawAmount),
          country: this.settlementForm.country.name,
          bank: this.settlementForm.bank,
          name: this.settlementForm.name,
          bankAccount: this.settlementForm.bankAccount,
          address: this.settlementForm.address,
        },
        params: { token: this.token, uid: this.uid },
      })
        .then(({ data }) => {
          if (data.code === 200) {
            // 提现成功：本地缓存 + 服务端保存平台结算信息（bindType=2, bizKey 写死 country）
            saveSettlementInfo(this.uid, this.settlementForm);
            saveBindInfo({
              bindType: BIND_TYPE_SETTLEMENT,
              bizKey: "country",
              info: this.settlementForm,
              serviceIp: this.$serviceIp,
              token: this.token,
              uid: this.uid,
              deviceId: this.deviceId,
              lang: this.lang,
            });
            this.showSuccess = true;
            // 501912 , 501918, 501923  都归为 性别认证失败场景,需性别认证
            // 501915 需真人认证拦截
          } else if (data.code === 501915 || data.code === 501918 || data.code === 501912 || data.code === 501923) {
            // 平台结算已解构响应体，统一从 data 读取认证错误码。
            this.certErrCode = data.code;
            this.showCertification = true;
          } else {
            Toast(data.message || this.$t("transfer.error"));
          }
        })
        .catch((err) => {
          Toast(this.$t("transfer.error"));
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    /** 成功弹窗「知道了」：关闭弹窗并回到提现首页 */
    goWithdrawalHome() {
      this.showSuccess = false;
      this.$router.replace("/withdrawal");
    },
  },
};
</script>

<style scoped>
.swc-page {
  min-height: 100vh;
  box-sizing: border-box; /* 含 padding-bottom，避免多余纵向滚动条 */
  overflow-x: hidden;
  background: #f5f6f8;
  font-family: "Montserrat", sans-serif;
  padding-bottom: calc(120px + env(safe-area-inset-bottom));
}

.swc-header-spacer {
  height: calc(88px + env(safe-area-inset-top));
}

.swc-header-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  padding-top: env(safe-area-inset-top);
  background: #f5f6f8;
}

.swc-header-inner {
  position: relative;
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.swc-back {
  position: absolute;
  left: 28px;
  top: 50%;
  transform: translateY(-50%);
  width: 64px;
  height: 64px;
}

.swc-title {
  margin: 0;
  font-size: 26px;
  font-weight: 600;
  font-family: 'Mada';
  color: #000;
}

.swc-body {
  padding: 0 28px;
  margin-top: 20px;
}

.swc-card {
  background: #fff;
  border-radius: 24px;
  padding: 8px 24px;
  margin-bottom: 20px;
}

.swc-row {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 0;
  font-size: 24px;
  border-bottom: 1px solid #f1f1f1;
  align-items: center;
}

.swc-row:last-child {
  border-bottom: none;
}

.swc-row > span:first-child {
  color: #89848D;
  flex-shrink: 0;
  font-weight: 400;
  width: 50%;
}

.swc-row-value {
  text-align: right;
  color: #000;
  word-break: break-all;
  font-weight: 500;
  width:  45%;
}

.swc-coin {
  display: inline-flex;
  align-items: end;
  font-weight: 700;
  color: #262427;
  flex-direction: column;
}

.swc-coin img {
  width: 28px;
  height: 28px;
  margin-right: 4px;
  vertical-align: top;
}

/* pocket 币后面的法币括号（cc num） */
.swc-fiat {
  /* margin-left: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #8a8a8f; */
}

/* 手续费左侧的固定值括号（cc feeFixed） */
.swc-fee-fixed {
  margin-left: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #8a8a8f;
}

.swc-warn {
  padding: 20px 24px;
  border-radius: 16px;
  font-size: 22px;
  line-height: 34px;
  color: #262427;
  background: linear-gradient(360deg, rgba(255, 147, 147, 0) 0%, rgba(255, 147, 147, 0.25) 100%);
}

.swc-warn > p:not(.swc-warn-title) {
  margin: 0;
  /* display: flex; */
}

.swc-warn-title {
  margin: 0 0 8px;
  font-size: 24px;
  font-weight: 500;
  color: #ff4365;
}

.swc-warn-title::before{
  display: inline-block;
  content: '';
  width: 32px;
  height: 32px;
  background: url('../../assets/withdrawal_v2/elert.png') no-repeat;
  background-size: 100% 100%;
  vertical-align: top;
  margin-right: 8px;
}
.swc-modify {
  color: #7b4dff;
  margin-left: 4px;
  unicode-bidi: isolate;
}

.swc-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 16px 28px calc(16px + env(safe-area-inset-bottom));
  background: #f5f6f8;
  display: flex;
  justify-content: center;
  align-items: center;
}

.swc-submit {
  width: 100%;
  max-width: 412px;
  height: 80px;
  border: none;
  border-radius: 40px;
  background: #8131E7;
  font-size: 24px;
  font-weight: 500;
  color: #fff;
}

.swc-submit:disabled {
  opacity: 0.6;
}

/* 阿语 RTL 适配（2026-06-08） */
html[lang="ar"] .swc-page {
  direction: rtl;
}

html[lang="ar"] .swc-back {
  left: auto;
  right: 28px;
  transform: translateY(-50%) rotateY(180deg);
}

html[lang="ar"] .swc-row-value {
  text-align: left;
}

html[lang="ar"] .swc-coin img {
  margin-right: 0;
  margin-left: 4px;
}

html[lang="ar"] .swc-warn-title::before {
  margin-right: 0;
  margin-left: 8px;
}

html[lang="ar"] .swc-modify {
  margin-left: 0;
  margin-right: 4px;
}
</style>
